import React from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import {Navigation} from 'swiper/modules';

export default () => {
    return (
        <Swiper className={`mySwiper`}
                navigation={true}
                modules={[Navigation]}
        >
            <SwiperSlide>
                <picture className={`guarantee-picture`}>
                    <source type={`image/webp`}
                            srcSet={`/storage/img/quality-guarantee/birka-zoloto.webp`}
                    />
                    <img src={`/storage/img/quality-guarantee/birka-zoloto.png`}
                         alt={`birka-zoloto`}
                         title={`birka-zoloto`}
                         loading={`lazy`}
                    />
                </picture>
                <div className={`swiper-lazy-preloader`}></div>
            </SwiperSlide>
            <SwiperSlide>
                <picture className={`guarantee-picture`}>
                    <source type={`image/webp`}
                            srcSet={`/storage/img/quality-guarantee/birka-zoloto-old.webp`}
                    />
                    <img src={`/storage/img/quality-guarantee/birka-zoloto-old.png`}
                         alt={`birka-zoloto`}
                         title={`birka-zoloto`}
                         loading={`lazy`}
                    />
                </picture>
                <div className={`swiper-lazy-preloader`}></div>
            </SwiperSlide>
            <SwiperSlide>
                <picture className={`guarantee-picture`}>
                    <source type={`image/webp`}
                            srcSet={`/storage/img/quality-guarantee/birka-serebro.webp`}
                    />
                    <img src={`/storage/img/quality-guarantee/birka-serebro.png`}
                         alt={`birka-zoloto`}
                         title={`birka-zoloto`}
                         loading={`lazy`}
                    />
                </picture>
                <div className={`swiper-lazy-preloader`}></div>
            </SwiperSlide>
            <SwiperSlide>
                <picture className={`guarantee-picture`}>
                    <source type={`image/webp`}
                            srcSet={`/storage/img/quality-guarantee/birka-serebro-old.webp`}
                    />
                    <img src={`/storage/img/quality-guarantee/birka-serebro-old.png`}
                         alt={`birka-zoloto`}
                         title={`birka-zoloto`}
                         loading={`lazy`}
                    />
                </picture>
                <div className={`swiper-lazy-preloader`}></div>
            </SwiperSlide>
        </Swiper>
    );
}
